module.exports = __webpack_public_path__ + "static/media/upload.35f8f603.svg";